import axios from 'axios';
export default {
    namespaced: true,
    state: {
        client: ""
    },

    getters: {
        getClient: (state) => {
            return state.client;
        }
    },

    mutations: {
        SET_CLIENT: (state, payload) => {
            state.client = payload.result
        },
    },

    actions: {
        get: async ({commit, rootState}, rfc) => {
            let {data} = await  rootState.init.http_common.get('/rfcs/'+rfc);
            commit('SET_CLIENT', data)
        },

        validateRfc: async ({rootState}, rfc) => {
            await  rootState.init.http_common.get('/validarrfc/' + rfc);
        },

        validateDataCustomer: async ({rootState}, params) => {
            console.log(rootState)
            await  axios.get('https://statuscfdi.sait.mx/validarreceptor',{
                params: {
                    rfc: params.rfc,
                    nombre: params.nomcli,
                    cp: params.cp,
                    regimen:params.regimen,
                    uso:'S01'
                }
            }).then(function (response) {
                if(response.status == 201){
                   throw response.data;
                }
                
                return
            });
        },

    }

}